import { p as promiseResolve, b as bootstrapLazy } from './index-55dc676f.js';

/*
 Stencil Client Patch Esm v2.11.0 | MIT Licensed | https://stenciljs.com
 */
var patchEsm = function patchEsm() {
  return promiseResolve();
};
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-highlight-code", [[1, "deckgo-highlight-code", {
      "language": [513],
      "highlightLines": [513, "highlight-lines"],
      "lineNumbers": [516, "line-numbers"],
      "terminal": [513],
      "editable": [4],
      "theme": [513],
      "revealProgress": [1025, "reveal-progress"],
      "themeStyle": [32],
      "loaded": [32],
      "highlightRows": [32],
      "load": [64],
      "reveal": [64],
      "hide": [64],
      "revealAll": [64],
      "hideAll": [64],
      "nextHighlight": [64],
      "prevHighlight": [64]
    }, [[5, "prismLanguageLoaded", "onLanguageLoaded"], [5, "prismLanguageError", "onLanguageError"], [8, "copy", "onCopyCleanZeroWidthSpaces"]]]]]], options);
  });
};
export { defineCustomElements };